// eslint-disable-next-line import/prefer-default-export
export class AIUnavailableError extends Error {
  /**
   * @param {{ cause?: unknown }} [options]
   */
  constructor(options) {
    super('The AI provider is unavailable', options);
    this.name = 'AIUnavailableError';
  }
}
